exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsvg[data-v-7d6464f6] {\n  margin: auto;\n  background: none;\n  display: block;\n  shape-rendering: auto;\n  position: absolute;\n  left: 30%;\n  z-index: 1;\n  width: 40%;\n  height: 100%;\n}", ""]);

// exports
